import "bootstrap";

const translatedError = t("error", "javascript.alert_modal");

function showAlert(msg = translatedError, title = translatedError) {
  $("#example-modal-label").html(title);
  $("#alert-msg").html(msg);
  $("#alert-msg-modal").modal();
}

window.showAlert = showAlert;
